import Image from 'next/image';

import { staticMediaUrl } from '@/fo/util/image-loader';

import { styles } from './HeroBanner.styles';

export function HeroBanner() {
  const slots = styles();

  return (
    <div className={slots.base()}>
      <div className={slots.container()}>
        <img
          src={staticMediaUrl('landing/bioderma_sebium/circle.png')}
          className={slots.circle()}
          width={497}
          height={570}
          loading="lazy"
          alt="Bioderma"
        />
        <div className={slots.imageWrapper()}>
          <picture>
            <source
              srcSet={staticMediaUrl(
                'landing/bioderma_sebium/hero-banner_sm2.jpg'
              )}
              media="(max-width: 767px)"
            />
            <img
              className={slots.imageHeroBanner()}
              src={staticMediaUrl('landing/bioderma_sebium/hero-banner_md.jpg')}
              alt="SÉbium kerato+ гель-крем"
              width={1920}
              height={1080}
              fetchPriority="high"
            />
          </picture>
          <Image
            src={staticMediaUrl('landing/bioderma_sebium/logo-recommend.svg')}
            className={slots.logoRecommend()}
            width={128}
            height={65}
            loading="lazy"
            alt="Рекомендовано дерматологами"
          />
        </div>
        <div className={slots.videoWrapper()}>
          <video
            className={slots.video()}
            src={staticMediaUrl(
              'landing/bioderma_sebium/hero-banner-video.mp4'
            )}
            width={1920}
            height={1080}
            autoPlay
            muted
            playsInline
            loop
            preload="metadata"
          />
          <div className={slots.videoContent()}>
            <p className={slots.videoContentText()}>
              раскройте потенциал
              <br /> вашей кожи
            </p>
            <img
              src={staticMediaUrl('landing/bioderma_sebium/hero-logo.png?1')}
              className={slots.videoLogo()}
              width={251}
              height={32}
              loading="lazy"
              alt="SÉbium kerato+ гель-крем"
            />
          </div>
        </div>
        <div className={slots.content()}>
          <picture>
            <source
              srcSet={staticMediaUrl(
                'landing/bioderma_sebium/hero-product_md.png?1'
              )}
              media="(max-width: 767px)"
            />
            <img
              className={slots.image()}
              src={staticMediaUrl(
                'landing/bioderma_sebium/hero-product_lg_2x-v2.png'
              )}
              alt="SÉbium kerato+ гель-крем"
              width={200}
              height={574}
              loading="eager"
              fetchPriority="high"
            />
          </picture>
          <div className={slots.contentText()}>
            <h1 className={slots.title()}>
              <span className={slots.subtitle()}>SÉbium</span>
              kerato+ гель-крем
            </h1>
            <p className={slots.description()}>
              Сокращает несовершенства
              <br />
              предотвращает появление новых
            </p>

            <div className={slots.info()}>
              <p className={slots.infoText()}>
                в <span className={slots.infoTextNumber()}>2</span> раза
              </p>
              <p className={slots.infoDescription()}>
                меньше
                <br /> несовершенств
                <sup className={slots.infoSup()}>2</sup>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
